<script setup>
import { useI18n } from "vue-i18n";
import { inject, onMounted, onUnmounted, watchEffect } from "vue";

const { t } = useI18n();
const isMenuOpen = inject('isMenuOpen');
const toggleMenu = inject('toggleMenu');

watchEffect(() => {
  document.body.style.overflow = isMenuOpen.value ? 'hidden' : '';
});

onMounted(() => {
  const navLinks = document.querySelectorAll('nav a');

  const closeMenu = () => {
    isMenuOpen.value = false;
  };

  navLinks.forEach(link => link.addEventListener('click', closeMenu));

  onUnmounted(() => {
    navLinks.forEach(link => link.removeEventListener('click', closeMenu));
  });
});

const scrollToSection = (id) => {
  const section = document.getElementById(id);
  if (section) {
    section.scrollIntoView({ behavior: "smooth" });
  }
};
</script>

<template>
  <header class="navbar">
    <div class="logo-container">
      <a :href="t('navbar.logoLink')"><img src="@/assets/logo/just-eat-logo.svg" alt="JustEat" title="JustEat"></a>
    </div>
    <div class="tc-link">
      <a :href="t('navbar.termsAndConditionsRefundLink')" target="_blank">{{t('navbar.termsAndConditionsRefund')}}</a>
    </div>
    <div class="hamburger" @click="toggleMenu">
      <span v-if="!isMenuOpen">
        <img src="@/assets/icons/menu.svg" alt="Open Menu" class="menu-icon">
      </span>
      <span v-else>
        <img src="@/assets/icons/icon-close-white.svg" alt="Close Menu" class="close-icon">
      </span>
    </div>
    <nav :class="{ 'active': isMenuOpen }">
      <ul>
        <li><a href="#faq" @click.prevent="scrollToSection('faq')">{{ t('navbar.faq') }}</a></li>
        <li><a :href="t('navbar.termsAndConditionsRefundLink')" target="_blank">{{ t('navbar.termsAndConditionsRefund') }}</a></li>
      </ul>
      <hr />
    </nav>
  </header>
</template>

<style scoped>
a {
  font-family: JETSansVF2, sans-serif;
  font-weight: 600;
  text-decoration: none;
  font-size: 18px;
  color: #242f30;
}

ul {
  list-style-type: none;
}

hr {
  width: 100%;
  border: 0;
  border-top: 2px solid #e0e0e0;
  margin-top: 30px;
}

.navbar {
  background: #f36805;
  padding: 16px 32px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.04), 0 8px 12px -2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.04);
  display: flex;
  justify-content: space-between;
  align-items: center;
}


.tc-link {
  display: flex;
  gap: 32px;
}

.tc-link a {
  color: #fafafa;
}


.logo-container {
  padding: 4px 0;
  width: 163px;
  height: 48px;
}

.hamburger {
  display: none;
  cursor: pointer;
}

.menu-icon {
  width: 30px;
  height: auto;
}

.close-icon {
  width: 20px;
  height: auto;
}

nav {
  display: none;
}

@media (max-width: 768px) {
  .tc-link {
    display: none;
  }

  .hamburger {
    display: block;
  }

  nav {
    position: absolute;
    top: 90px;
    right: 0;
    background: #fff;
    width: 100%;
    height: 100vh;
    display: none;
    flex-direction: column;
    padding: 50px;
    box-sizing: border-box;
  }

  nav.active {
    display: flex;
    z-index: 10;
  }

  nav ul {
    flex-direction: column;
    padding: 0;
    margin: 0;
  }

  nav li {
    padding: 10px 0;
  }
}
</style>